import * as React from 'react';

/**
 * Variant of the a instance select component.
 */
export enum InstanceSelectVariant {
  Primary = 'primary',
  Accent = 'accent',
}

/**
 * The props interface of the instance select component.
 * @param {InstanceSelectVariant | undefined} variant
 * @param {React.HTMLAttributes<HTMLInputElement> | undefined} input
 * @param {void | undefined} onAddClick
 * @param {JSX.Element | JSX.Element[]} children
 */
export interface InstanceSelectProps {

  /**
   * Variant of theme.
   * @type {InstanceSelectVariant}
   */
  variant?: InstanceSelectVariant;

  /**
   * Custom input props.
   * @type {React.HTMLAttributes<HTMLInputElement> | undefined}
   */
  input?: React.HTMLAttributes<HTMLInputElement>;

  /**
   * Event when click on add control.
   * @param {React.HTMLAttributes<HTMLInputElement>["defaultValue"]} value
   */
  onAddClick?(
    value: React.HTMLAttributes<HTMLInputElement>['defaultValue']
  ): void;

  /**
   * Dropdown content.
   * @type {JSX.Element | JSX.Element[]}
   */
  children: JSX.Element | JSX.Element[];

}
